import { handleApi } from "../common";
export const ADD_FUNDS_PAYMENTS_CONSTANT = {
    'validateVpa': '/api/equity/api/eqm/eqpayments/vpa/validate',
    'fetchNeftDetails': 'api/equity/api/eqm/eqpayments/neft/details',
    'validateMfVpa': '/api/invest/validate/vpa',
}


export const validate_vpa = async (Api, params) => {
    const response = await Api.post(ADD_FUNDS_PAYMENTS_CONSTANT.validateVpa, params);
    return handleApi(response);
}

export const fetch_neft_details = async (Api) => {
    const response = await Api.get(ADD_FUNDS_PAYMENTS_CONSTANT.fetchNeftDetails);
    return handleApi(response);
}

export const validate_mf_vpa = async (Api, params) => {
    const response = await Api.post(ADD_FUNDS_PAYMENTS_CONSTANT.validateMfVpa, params);
    return handleApi(response);
}